import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {
    AiTranscriptionImproveServicePayload,
    AiTranscriptionImproveServiceResult
} from "./aiTranscriptionImprove.service";
import {environment} from "../../../../../../environments/environment";
import {
    AudioTranscriptionHandlerGetTermsResult
} from "../../../../common/audio/transcription/api/component/audio-transcription-v2/audio-transcription-v2.component";

@Injectable({
    providedIn: 'root'
})
export class AiTranscriptionEntityGetPotentialTermsService {

    constructor(private httpClient: HttpClient){
    }

    execute(entityName: string, customPayload: any): Promise<AudioTranscriptionHandlerGetTermsResult> {
        return this.httpClient.post<AudioTranscriptionHandlerGetTermsResult>(environment.webserviceUrl + '/v1/ai/transcription/get-potential-terms', {
            common: {
                entityName,
            },
            custom: customPayload
        })
            .toPromise();
    }
}